import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';

export const CREATE_CTC_CREDENTIAL = 'CREATE_CTC_CREDENTIAL';
export const UPDATE_CTC_CREDENTIAL = 'UPDATE_CTC_CREDENTIAL';
export const GET_CTC_CREDENTIAL = 'GET_CTC_CREDENTIAL';
export const GET_CTC_CREDENTIAL_BY_ID = 'GET_CTC_CREDENTIAL_BY_ID';

const createCtcCredentialAction = (payload) => ({
  type: CREATE_CTC_CREDENTIAL,
  payload,
});
const updateCtcCredentialAction = (payload) => ({
  type: UPDATE_CTC_CREDENTIAL,
  payload,
});
const getCtcCredentialAction = (payload) => ({
  type: GET_CTC_CREDENTIAL,
  payload,
});
const getCtcCredentialByIdAction = (payload) => ({
  type: GET_CTC_CREDENTIAL_BY_ID,
  payload,
});

export const createCtcCredential = (adminId, data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/ivr/credential/create/${adminId}`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (res?.data?.data?._id) {
        toast.success('IVR credentials saved successfully');
      } else {
        toast.error(
          res?.data?.data?.message || 'Failed to save IVR credentials',
        );
      }
      dispatch(createCtcCredentialAction(res));
      return res;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Something went wrong while saving IVR credentials',
      );
      dispatch(createCtcCredentialAction(error?.response));
      return error?.response;
    }
  };
};

export const updateCtcCredential = (credentialId, data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.put(
        `${BASEURL}/ivr/credential/update/${credentialId}`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (res?.data?.data?._id) {
        toast.success('IVR credentials updated successfully');
      } else {
        toast.error('IVR credentials could not be updated');
      }
      dispatch(updateCtcCredentialAction(res));
      return res;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Something went wrong while updating IVR credentials',
      );
      dispatch(updateCtcCredentialAction(error?.response));
      return error?.response;
    }
  };
};

export const getCtcCredential = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASEURL}/ivr/credential/get`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(getCtcCredentialAction(res));
      return res;
    } catch (error) {
      dispatch(getCtcCredentialAction(error?.response));
      return error?.response;
    }
  };
};

export const getCtcCredentialById = (adminId) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(
        `${BASEURL}/ivr/credential/getbyid/${adminId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      dispatch(getCtcCredentialByIdAction(res));
      return res;
    } catch (error) {
      dispatch(getCtcCredentialByIdAction(error?.response));
      return error?.response;
    }
  };
};
